import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '../lib/utils';

type SvgProps = ComponentPropsWithoutRef<'svg'>;

function IconBase({ className, children, ...props }: SvgProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('size-icon-sm', className)}
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function InboxIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </IconBase>
  );
}

export function DraftIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </IconBase>
  );
}

export function FlagIcon({
  className,
  filled = false,
  ...props
}: SvgProps & { filled?: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('size-icon-sm', className)}
      aria-hidden="true"
      {...props}
    >
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
      <line x1="4" y1="22" x2="4" y2="15" />
    </svg>
  );
}

export function ReplyIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <polyline points="9 17 4 12 9 7" />
      <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
    </IconBase>
  );
}

export function ReplyAllIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <polyline points="7 17 2 12 7 7" />
      <polyline points="12 17 7 12 12 7" />
      <path d="M22 18v-2a4 4 0 0 0-4-4H7" />
    </IconBase>
  );
}

export function ForwardIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <polyline points="15 17 20 12 15 7" />
      <path d="M4 18v-2a4 4 0 0 1 4-4h12" />
    </IconBase>
  );
}

export function AttachmentIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </IconBase>
  );
}

export function SpamIcon({
  className,
  filled = false,
  ...props
}: SvgProps & { filled?: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('size-icon-sm', className)}
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
    </svg>
  );
}

export function AddressBookIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <path d="M20 6l-8 5-8-5" />
      <line x1="4" y1="12" x2="8" y2="12" />
    </IconBase>
  );
}

export function FilterIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </IconBase>
  );
}

export function SelectIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <polyline points="20 6 9 17 4 12" />
    </IconBase>
  );
}

export function SearchIcon({ className, ...props }: SvgProps) {
  return (
    <IconBase className={className} {...props}>
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </IconBase>
  );
}
